import ForgotPassword from '../components/Authentication/ForgotPassword';

export default function ForgotPasswordPage() {
	return <ForgotPassword />;
}
